import { render, staticRenderFns } from "./OrderAcceptedByResearcher.vue?vue&type=template&id=607dc5ae"
import script from "./OrderAcceptedByResearcher.vue?vue&type=script&lang=js"
export * from "./OrderAcceptedByResearcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports